import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Actions
import activityActions from '../../../actions/activity';
import modalActions from '../../../actions/modal';
import actions from '../../../actions/lexique';

// Components
import Breadcrumbs from '../../tools/breadcrumbs/Breadcrumbs';
import Card from '../../cards/card/Card';
import CardGrid from '../../cards/cardGrid/CardGrid';
import CardSlider from '../../cards/cardSlider/CardSlider';
import ImageGallery from '../parts/imageGallery/ImageGallery';
import LinedTitle from '../../tools/linedTitle/LinedTitle';
import Loader from '../../tools/loader/Loader';
import RelatedContent from '../parts/RelatedContent';
import SingleTitle from '../parts/SingleTitle';
import Sharer from '../../tools/share/Sharer';
import RecommendationModal from './parts/recommendationModal/recommendationModal';
import ImageModal from './parts/imageModal/ImageModal';
import Resources from '../parts/Resources';
import TableSpecs from '../../tools/wysiwyg/parts/tableSpecs/TableSpecs';
import Wysiwyg from '../../tools/wysiwyg/Wysiwyg';
import NotFound from '../../pages/NotFound';
import createInfoBulle from '../parts/InfoBulle';
// import InfoBulleTest from '../parts/InfoBulleTest';

// Functions
import { getHelmetTags, getLoadingHelmetTags } from '../../tools/helmetHelpers';

// Styles
import '../styles.scss';
import './styles.scss';
import InfoBulleReference from '../parts/InfoBulleReference';

class Activity extends Component {
  constructor(props, { initialRender, customStore }) {
    super(props);
    this.imageContainerRef = React.createRef();
    this.lexiconElementsRef = React.createRef([]);
    this.lexiconElementsRef.current = [];
    this.state = {
      imageContainerHeight: 0,
      hasRecommended: false,
    };
    this.shareInformations = {
      url: window ? window.location.href : '',
      image: '',
      description: '',
    };

    this.showRecommendationModal = this.showRecommendationModal.bind(this);
    this.updateImageContainerHeight = this.updateImageContainerHeight.bind(this);
    this.updateActivity = this.updateActivity.bind(this);
    if (initialRender) {
      if (props.preview) {
        props.getActivityPreview(props.match.params.slug, customStore);
      } else {
        props.getActivity(props.match.params.slug, customStore);
      }
    }
  }

  componentDidMount() {
    const {
      activity,
      getActivity,
      getActivityPreview,
      match: { params: { slug } },
      preview,
    } = this.props;

    if (Object.keys(activity).length === 0) {
      if (preview) {
        getActivityPreview(slug);
      } else {
        getActivity(slug);
      }
    }

    window.addEventListener('resize', this.updateImageContainerHeight);
    this.updateImageContainerHeight();
  }

  componentDidUpdate(prevProps) {
    const { match: { params: { slug: prevSlug } } } = prevProps;
    const { match: { params: { slug } } } = this.props;
    if (prevSlug !== slug) {
      this.updateActivity();
    }
  }

  componentWillUnmount() {
    const { reinitializeActivity } = this.props;
    reinitializeActivity();
    window.removeEventListener('resize', this.updateImageContainerHeight);
  }

  showRecommendationModal() {
    const { incrementRecommendations, activity: { id }, showModal } = this.props;
    const { hasRecommended } = this.state;
    const {
      url,
      image,
      description,
    } = this.shareInformations;

    if (!hasRecommended) {
      incrementRecommendations(id);
      this.setState(() => ({
        hasRecommended: true,
      }));
    }

    showModal(
      RecommendationModal,
      {
        shareUrl: url,
        shareImgUrl: image,
        shareDescription: description,
      },
    );
  }

  updateActivity() {
    const { match: { params: { slug } }, getActivity } = this.props;

    getActivity(slug);
    this.setState({ hasRecommended: false });
    this.updateImageContainerHeight();
  }

  updateImageContainerHeight() {
    if (this.imageContainerRef.current !== null) {
      this.setState({
        imageContainerHeight: this.imageContainerRef.current.offsetHeight,
      });
    }
  }
  infoBulleRef = () => {
    const { fetchLexiqueSlug } = this.props;
    InfoBulleReference(fetchLexiqueSlug, this.lexiconElementsRef.current, 'desc');
  }
  render() {
    const { t, request } = this.context;
    const {
      activity: {
        activityTypes = [],
        artworks = [],
        contentDisplay,
        contentType,
        contentWysiwyg,
        description,
        durations = [],
        evaluationGrid = {},
        images = [],
        materials = [],
        otherActivities = [],
        recommendationsContent = {},
        recommendationsImages = [],
        recommendedCount = 0,
        resourcesFiles = [],
        resourcesVideos = [],
        schoolLevels = [],
        steps = [],
        suggestionsLinks = [],
        suggestionsMedias = [],
        title = '',
        seoData,
      },
      showModal,
      isLoading,
      notFound,
      lexiqueResultsSlug,
    } = this.props;
    const lxLength = lexiqueResultsSlug.length;
    const lexiqueRefs = this.lexiconElementsRef.current;
    if (lxLength !== 0 && lexiqueRefs.length === lxLength) {
      createInfoBulle(lexiqueResultsSlug, lexiqueRefs, 'desc');
    }
    // 404
    if (notFound) return <NotFound />;

    const {
      imageContainerHeight,
      hasRecommended,
    } = this.state;
    const minHeightStyle = { minHeight: imageContainerHeight };

    let shareUrl = '';
    if (request) {
      shareUrl = [request.protocol, '://', request.headers.host, request.originalUrl].join('');
    } else if (window) {
      shareUrl = window.location.href;
    }
    const shareImgUrl = seoData && seoData.image ? seoData.image.medium : '';
    const shareDescription = seoData ? seoData.description : '';
    return (
      <div>
        {isLoading ? getLoadingHelmetTags(t) : getHelmetTags(t, seoData, t('pages.activity.title'))}
        {isLoading ?
          <Loader loading={isLoading} fullscreen />
          :
          <Fragment>
            <div className="section section--full-width">
              <article className="single">
                <div className="single__header">
                  <Breadcrumbs contentType={contentType} title={title} />
                  <div>
                    <Sharer
                      shareUrl={shareUrl}
                      shareImgUrl={shareImgUrl}
                      shareDescription={shareDescription}
                    />
                  </div>
                </div>
                <div className="single__columns" style={minHeightStyle}>
                  <SingleTitle
                    title={title}
                    subtitle={activityTypes.join(', ')}
                  />
                  <div className="single__image" ref={this.imageContainerRef}>
                    <ImageGallery
                      medias={images}
                      updateImageContainerHeight={this.updateImageContainerHeight}
                    />
                  </div>
                  <div className="single__details single__columns__content">
                    <Wysiwyg>
                      <TableSpecs
                        specs={[
                          {
                            name: t('pages.activity.schoolLevel'),
                            value: schoolLevels.map((shoolLevel) => shoolLevel.name),
                          },
                          {
                            name: t('pages.activity.duration'),
                            value: durations.map((duration) => duration.name),
                          },
                        ]}
                      />
                      {recommendedCount > 0 &&
                        <div className="single__recommended-count">
                          <span className="tag tag--fill">
                            {t(
                              'pages.activity.recommendedCount',
                              { n: recommendedCount !== null ? recommendedCount : 0 },
                            )}
                          </span>
                        </div>
                      }
                      <div className="single__details__text">
                        {description !== '' &&
                        // eslint-disable-next-line max-len
                          <div id="desc" dangerouslySetInnerHTML={{ __html: description }} ref={this.infoBulleRef} />
                        }
                      </div>
                    </Wysiwyg>
                  </div>
                  {(artworks.length > 0 && artworks.length <= 2) &&
                  <div className="single__details__artworks">
                    <h5 className="activity-details__heading">
                      {t('pages.activity.inspiredBy')}
                    </h5>
                    <CardGrid>
                      {artworks.map((artwork) =>
                        <div className="grid__item" key={`artworkCard-${artwork.slug}-${artwork.id}`}>
                          <Card
                            {...artwork}
                            horizontal
                          />
                        </div>,
                      )}
                    </CardGrid>
                  </div>
                  }
                </div>
              </article>
            </div>
            {artworks.length > 2 &&
              <div className="section activity-artworks">
                <div className="annex">
                  <h5 className="annex__heading annex__heading--left">
                    {t('pages.activity.inspiredBy')}
                  </h5>
                  <CardSlider
                    settings={{
                      arrows: true,
                      dots: false,
                      slidesToShow: 3,
                      infinite: true,
                      responsive: [
                        {
                          breakpoint: 1050,
                          settings: {
                            slidesToShow: 2,
                          },
                        },
                        {
                          breakpoint: 767,
                          settings: {
                            slidesToShow: 2,
                            infinite: false,
                            arrows: false,
                            dots: true,
                          },
                        },
                        {
                          breakpoint: 608,
                          settings: {
                            slidesToShow: 1,
                            infinite: false,
                            arrows: false,
                            dots: true,
                          },
                        },
                      ],
                    }}
                  >
                    {artworks.map((artwork) =>
                      <div className="grid__item" key={`artworkCard-${artwork.slug}-${artwork.id}`}>
                        <Card
                          {...artwork}
                          horizontal
                        />
                      </div>,
                    )}
                  </CardSlider>
                </div>
              </div>
            }
            <div className="section linked-activities">
              <div className="activity-details">
                <div className="activity-details__column">
                  {(contentDisplay === 'steps' && materials.length > 0) &&
                    <Fragment>
                      <span className="activity-details__heading">
                        {t('pages.activity.material')}
                      </span>
                      <ul className="activity-details__material">
                        {materials.map((material) => <li key={material}>{material}</li>)}
                      </ul>
                    </Fragment>
                  }
                  {evaluationGrid && evaluationGrid.length > 0 &&
                    <div className="activity-details__evaluations">
                      {evaluationGrid.map((card) =>
                        <Card
                          cardType="resource"
                          title={card.label}
                          resourceType="file"
                          url={card.file.url || card.link}
                          withoutDetails
                        />,
                      )}
                    </div>
                  }
                </div>
                <div className="activity-details__column">
                  {(contentDisplay === 'steps' && steps.length > 0) &&
                    <Fragment>
                      <span className="activity-details__heading">
                        {t('pages.activity.steps')}
                      </span>
                      <ol className="activity-details__steps">
                        {steps.map(({ step, image: { thumbnail, full, alt } }) =>
                          <li key={step}>
                            <div className="activity-details__step">
                              <div
                                className="activity-details__step__text"
                                dangerouslySetInnerHTML={{ __html: step }}
                              />
                              {(thumbnail && full) &&
                              <button
                                className="activity-details__step__image"
                                onClick={() => showModal(
                                  ImageModal,
                                  {
                                    mediaUrl: full,
                                    alt,
                                    description: step,
                                  },
                                )}
                              >
                                <span />
                                <img
                                  src={thumbnail}
                                  alt={alt}
                                />
                              </button>
                              }
                            </div>
                          </li>,
                        )}
                      </ol>
                    </Fragment>
                  }
                  {contentDisplay === 'wysiwyg' &&
                    <Wysiwyg>
                      <div dangerouslySetInnerHTML={{ __html: contentWysiwyg }} />
                    </Wysiwyg>
                  }
                </div>
              </div>
            </div>
            <div className="section">
              <Resources
                contentType="activity"
                resourcesFiles={resourcesFiles}
                resourcesVideos={resourcesVideos}
                suggestionsLinks={suggestionsLinks}
                suggestionsMedias={suggestionsMedias}
              />
            </div>
            {(recommendationsContent.title && recommendationsContent.text) &&
              <div className="section activity-artworks activity-artworks--recommendation">
                <div className="annex">
                  <LinedTitle
                    title={recommendationsContent.title}
                  />
                  <div className="activity-recommendation">
                    {recommendationsImages.length > 0 &&
                      <ul className="activity-recommendation__gallery">
                        {recommendationsImages.map((image) =>
                          <li key={`recommendationImg-${image.name}-${image.ID}`}>
                            <button
                              className="activity-recommendation__gallery__item"
                              onClick={() => showModal(
                                ImageModal,
                                {
                                  mediaUrl: image.sizes.large,
                                  alt: image.alt,
                                  description: image.description,
                                },
                              )}
                            >
                              <span />
                              <img
                                src={image.sizes.large}
                                alt={image.alt}
                              />
                            </button>
                          </li>,
                        )}
                      </ul>
                    }
                    <div className="activity-recommendation__text">
                      <Wysiwyg>
                        <div dangerouslySetInnerHTML={{ __html: recommendationsContent.text }} />
                      </Wysiwyg>
                      <button
                        className={classNames(
                          'button button--fill',
                          'button--icon', {
                          'button--recommended': hasRecommended,
                        })}
                        onClick={() => this.showRecommendationModal()}
                      >
                        {t(`pages.activity.${hasRecommended ? 'isRecommended' : 'recommendThis'}`)}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
            {otherActivities.length > 0 &&
              <RelatedContent
                title={t('pages.activity.otherActivities.title')}
              >
                {otherActivities.map((card) =>
                  <div className="grid__item" key={`activityCard-${card.slug}-${card.id}`}>
                    <Card
                      {...card}
                    />
                  </div>,
                )}
              </RelatedContent>
            }
          </Fragment>
        }
      </div>
    );
  }
}

Activity.propTypes = {
  activity: PropTypes.object.isRequired,
  getActivity: PropTypes.func.isRequired,
  getActivityPreview: PropTypes.func.isRequired,
  incrementRecommendations: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  preview: PropTypes.bool,
  reinitializeActivity: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  notFound: PropTypes.bool.isRequired,
  fetchLexiqueSlug: PropTypes.func.isRequired,
  lexiqueResultsSlug: PropTypes.array.isRequired,
};

Activity.defaultProps = {
  preview: false,
};

Activity.contextTypes = {
  customStore: PropTypes.object,
  initialRender: PropTypes.bool,
  t: PropTypes.func,
  request: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    activity: state.activity.postData,
    isLoading: state.activity.isLoading,
    notFound: state.activity.notFound,
    lexiqueResultsSlug: state.lexique.lexiqueResultsSlug,
  };
}

export default withRouter(connect(
  mapStateToProps,
  { ...activityActions, ...modalActions, ...actions },
)(Activity));



// WEBPACK FOOTER //
// ./src/app/components/singles/activity/Activity.js